<template>
    <span>
        <a class="c_qtydiscountVue" @click.prevent="openModal">{{labels[1003]}}<!-- qty discounts --></a>

        <!-- MODAL WINDOW -->
        <modal v-if="isModalVisible" @close="closeModal" class="megapadding">
            <template v-slot:header>
                <span class="ui-dialog-title">{{labels[1032]}}</span><!-- label: Quantity Discounts -->
            </template>

            <template v-slot:body>
                <div class="megapadding">
                    <h3>{{item.products[0].c_part}}</h3>
                    <table class="table table-condensed table-striped">
                        <thead>
                            <tr>
                                <td>{{labels[1096]}}<!-- Quantity --></td>
                                <td>{{labels[997]}}<!-- Item Price --></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="disc in discData" :key="disc">
                                <td>
                                    <template v-if="disc.not_last_row">
                                        {{disc.num}} - {{disc.qty_to}}
                                    </template>
                                    <template v-else>
                                        {{disc.num}} +
                                    </template>
                                </td>
                                <td>{{disc.price}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>

            <template v-slot:footer>
                <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                    <div class="ui-dialog-buttonset">
                        <button type="button" @click="closeModal" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button">
                            <span class="ui-button-text">{{labels[1031]}}</span><!-- label: Close -->
                        </button>
                    </div>
                </div>
            </template>
        </modal>
    </span>
</template>

<script>
import { ref } from '@vue/composition-api'
import axios from "axios";
import useAlerts from '../../shared/composables/useAlerts'
import useCMS from "../../shared/composables/useCMS"
import Modal from '../../shared/components/Modal.vue';
import useCart from "../composables/useCart"

export default {
    name: 'QtyDiscountLink',
    components: {
        Modal
    },
    props: {
        item: Object
    },
    setup (props) {
        const { cart } = useCart();
        const { addAlert } = useAlerts();
        const { labels } = useCMS();
        const { isModalVisible, closeModal, openModal } = useDiscountModal();

        const discData = ref([]);

        const getData = () => {
            var params = new URLSearchParams({
                model: props.item.products[0].model,
                part: props.item.products[0].model,
                config: props.item.products[0].c_part,
                plist: props.item.products[0].partlist,
                price_code: cart.value.reqPricing
            });

            axios.post('/actions/cart.cfc?method=getQtyDiscountData', params).then(
                (resp) => {
                    if (resp.status === 200){
                        discData.value = resp.data;
                    }
                }).catch((err) => {
                    addAlert('An error occurred retrieving quantity discount data.', 'alert-danger', 7000);
                    console.log(err);
                });
        }

        getData();

        return {
            labels,
            isModalVisible,
            closeModal,
            openModal,
            discData
        }
    }
}

function useDiscountModal () {
    const isModalVisible = ref(false);

    const closeModal = () => {
        isModalVisible.value = false;
    }

    const openModal = () => {
        isModalVisible.value = true;
    }

    return {
        isModalVisible,
        closeModal,
        openModal
    }
}

</script>
